module.exports = __webpack_public_path__ + "static/media/att-comm-notify.83b851c1.svg";